import { ActionIcon, ScrollArea } from "@mantine/core";
import React, { useEffect } from "react";
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import { Storage } from "aws-amplify";

const TOGGLE_PIXEL_NUMBER = 100;
//const WIDTH_GAP = 457;

const BulkPhotoView = ({ file, isPdf }: { file?: string; isPdf: boolean }) => {
  const viewport = React.useRef<HTMLDivElement>(null);
  const [currentWidth, setCurrentWidth] = React.useState({ x: 0, y: 0 });
  const [imageUrls, setImageUrls] = React.useState<string[]>([""]);

  /**
   * This method is used in Gallery view when have to scroll left
   */
  const scrollToLeft = () => {
    if (viewport.current) {
      setCurrentWidth({
        x: currentWidth.x - TOGGLE_PIXEL_NUMBER,
        y: currentWidth.y,
      });
      return viewport.current.scrollTo({
        left: currentWidth.x - TOGGLE_PIXEL_NUMBER,
        behavior: "smooth",
      });
    }
  };

  /**
   * This method is used in Gallery view when have to scroll right
   */
  const scrollToRight = () => {
    if (viewport.current) {
      setCurrentWidth({
        x: currentWidth.x + TOGGLE_PIXEL_NUMBER,
        y: currentWidth.y,
      });
      return viewport.current.scrollTo({
        left: currentWidth.x + TOGGLE_PIXEL_NUMBER,
        behavior: "smooth",
      });
    }
  };

  /**
   * This method is used to get preview image from s3 to display
   */
  const getFile = async () => {
    if (!file) return;
    let response;
    if (!isPdf) {
      response = await Storage.get(file);
      setImageUrls([response]);
    } else {
      const fileName = file.split(".")[0];
      const responseList = await Storage.list(`${fileName}/photo/`);
      const imageUrls: string[] = [];
      if (Array.isArray(responseList)) {
        for (let value of responseList) {
          if (value && value.key) {
            const url = await Storage.get(value.key);
            imageUrls.push(url);
          }
        }
      } else {
        console.error("responseList ist kein Array:", responseList);
      }
      setImageUrls(imageUrls);
    }
  };

  useEffect(() => {
    getFile();
  }, [file]);

  return (
    <div className="grid">
        {imageUrls.length > 1 && (
          <ActionIcon
            radius={0}
            style={{
              pointerEvents: "auto",
              height: "100%",
            }}
            onClick={() => {
              scrollToLeft();
            }}
          >
            <AiOutlineLeft size="1.125rem" />
          </ActionIcon>
        )}

      <ScrollArea
        type="never"
        viewportRef={viewport}
        onScrollPositionChange={setCurrentWidth}
      >
        <div className="row">
          {imageUrls.map((i, ind) => (
            <img key={ind} src={i} alt={`Thumbnail_${ind}`} />
          ))}
        </div>
      </ScrollArea>
        {imageUrls.length > 1 && (
          <ActionIcon
            radius={0}
            style={{
              pointerEvents: "auto",
              height: "100%",
            }}
            onClick={() => {
              scrollToRight();
            }}
          >
            <AiOutlineRight size="1.125rem" />
          </ActionIcon>
        )}
    </div>
  );
};

export default BulkPhotoView;
